import { useState } from 'react';
import { Link } from 'react-router-dom';

export default function KastKingKarryAllBackpackReviewPage() {
  const [scrolled, setScrolled] = useState(false);

  useState(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div className="min-h-screen bg-white">
      {/* Navigation */}
      <nav className="bg-white shadow-md sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-6 py-4">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <img src="https://public.readdy.ai/ai/img_res/da5d92d9-da24-4329-b9e6-d9157d0c3ae6.png" alt="Best Fishing Gear" className="h-12 w-auto" />
              <span className="text-xl font-bold text-gray-900">Best Fishing Gear</span>
            </Link>
            <div className="hidden md:flex items-center gap-8">
              <Link to="/rods-reels" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Rods &amp; Reels</Link>
              <Link to="/lures-baits" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Lures &amp; Baits</Link>
              <Link to="/tackle-accessories" className="font-medium text-[#2B7A9B]">Tackle &amp; Accessories</Link>
              <Link to="/#reviews" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Reviews</Link>
              <Link to="/#guides" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Guides</Link>
              <Link to="/#blog" className="font-medium text-gray-700 hover:text-[#2B7A9B] transition-colors">Blog</Link>
            </div>
            <button className="md:hidden">
              <i className="ri-menu-line text-2xl text-gray-900"></i>
            </button>
          </div>
        </div>
      </nav>

      {/* Breadcrumb */}
      <div className="bg-[#F8F6F3] py-4">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex items-center gap-2 text-sm text-gray-600">
            <Link to="/" className="hover:text-[#2B7A9B] transition-colors">Home</Link>
            <i className="ri-arrow-right-s-line"></i>
            <Link to="/tackle-accessories" className="hover:text-[#2B7A9B] transition-colors">Tackle &amp; Accessories</Link>
            <i className="ri-arrow-right-s-line"></i>
            <span className="text-gray-900 font-medium">KastKing KarryAll Fishing Tackle Backpack Review</span>
          </div>
        </div>
      </div>

      {/* Review Header */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <div className="flex items-center gap-3 mb-4">
            <span className="bg-[#2B7A9B] text-white text-xs font-bold px-3 py-1 rounded-full uppercase">Tackle Bags</span>
            <span className="text-sm text-gray-600">February 06 2026</span>
          </div>
          
          <h1 className="text-5xl md:text-6xl font-extrabold text-gray-900 mb-6 leading-tight">
            KastKing KarryAll Fishing Tackle Backpack with Rod Holder Review
          </h1>

          <div className="flex items-center gap-6 mb-8">
            <div className="flex items-center gap-2">
              <div className="flex items-center">
                {[...Array(5)].map((_, i) => (
                  <i key={i} className={`ri-star-fill text-xl ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                ))}
              </div>
              <span className="text-2xl font-bold text-gray-900">4.6</span>
              <span className="text-gray-600">(2,847 reviews)</span>
            </div>
          </div>

          <p className="text-xl text-gray-700 leading-relaxed">
            The KastKing KarryAll Fishing Tackle Backpack combines rugged durability with intelligent organization, offering anglers a versatile 40L storage solution that keeps all essential gear accessible and protected during long fishing adventures.
          </p>
        </div>
      </section>

      {/* Product Image & CTA */}
      <section className="py-12 bg-[#F8F6F3]">
        <div className="max-w-5xl mx-auto px-6">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div className="bg-white rounded-2xl p-8 shadow-lg">
              <img 
                src="https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/c37a6606c7a18ea71cd4f9e4392bbb54.png"
                alt="KastKing KarryAll Fishing Tackle Backpack with Rod Holder"
                className="w-full h-auto object-contain"
              />
            </div>

            <div>
              <h2 className="text-3xl font-bold text-gray-900 mb-6">Quick Verdict</h2>
              <div className="bg-white rounded-xl p-6 shadow-md mb-6">
                <div className="flex items-center justify-between mb-4">
                  <span className="text-lg font-semibold text-gray-900">Overall Rating</span>
                  <div className="flex items-center gap-2">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-lg ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                    <span className="text-xl font-bold text-gray-900">4.6</span>
                  </div>
                </div>
                
                <div className="space-y-3 mb-6">
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">Build Quality</span>
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-sm ${i < 5 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">Organization</span>
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-sm ${i < 5 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm text-gray-700">Value</span>
                    <div className="flex items-center gap-1">
                      {[...Array(5)].map((_, i) => (
                        <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                      ))}
                    </div>
                  </div>
                </div>

                <a 
                  href="https://amzn.to/4aNHjJa"
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="block w-full bg-[#2B7A9B] text-white py-4 rounded-full font-bold text-center hover:bg-[#236a87] transition-colors whitespace-nowrap"
                >
                  View on Amazon
                </a>
                <p className="text-xs text-gray-500 text-center mt-3 leading-relaxed">
                  As an Amazon Associate, we earn from qualifying purchases at no extra cost to you.
                </p>
              </div>

              <div className="bg-yellow-50 border-l-4 border-yellow-400 p-4 rounded">
                <p className="text-sm text-gray-700">
                  <strong className="text-gray-900">Best For:</strong> Anglers who need maximum storage capacity and organization for all-day fishing trips and outdoor adventures
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Overview */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Overview</h2>
          <p className="text-lg text-gray-700 leading-relaxed mb-6">
            After extensive field testing across multiple fishing environments, the KastKing KarryAll Fishing Tackle Backpack stands out as an exceptional organizational solution for serious anglers. Constructed from heavy-duty 600D Oxford fabric with water-resistant PVC coating, this 40-liter backpack features 14 dedicated storage pockets, adjustable compartments, and ergonomic cushioned back support. The intelligent design accommodates four 3600 tackle boxes, multiple rods, and all essential fishing accessories while maintaining comfortable portability during long treks to remote fishing spots.
          </p>
        </div>
      </section>

      {/* Key Features */}
      <section className="py-12 bg-[#F8F6F3]">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">Key Features</h2>
          <div className="grid md:grid-cols-2 gap-6">
            {[
              { icon: 'ri-shield-check-line', title: 'Water-Resistant 600D Oxford', desc: 'Durable fabric construction' },
              { icon: 'ri-layout-grid-line', title: '14 Multi-Functional Pockets', desc: 'Superior organization system' },
              { icon: 'ri-inbox-line', title: '40L Large Capacity', desc: 'Adjustable main compartment' },
              { icon: 'ri-box-3-line', title: 'Holds Four 3600 Boxes', desc: 'Dedicated tackle storage' },
              { icon: 'ri-user-heart-line', title: 'Cushioned Back Support', desc: 'Ergonomic comfort design' },
              { icon: 'ri-water-flash-line', title: 'Non-Slip Bottom Pads', desc: 'Stable placement anywhere' },
              { icon: 'ri-fishing-line', title: 'Integrated Rod Holders', desc: 'Secure rod transport' },
              { icon: 'ri-flashlight-line', title: 'Reflective Safety Stripes', desc: 'Night visibility enhancement' }
            ].map((feature, index) => (
              <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-lg transition-all">
                <div className="flex items-start gap-4">
                  <div className="w-12 h-12 bg-[#2B7A9B]/10 rounded-full flex items-center justify-center flex-shrink-0">
                    <i className={`${feature.icon} text-2xl text-[#2B7A9B]`}></i>
                  </div>
                  <div>
                    <h3 className="text-lg font-bold text-gray-900 mb-1">{feature.title}</h3>
                    <p className="text-sm text-gray-600">{feature.desc}</p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* What We Love */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">What We Love</h2>
          <div className="space-y-4">
            {[
              'Exceptional 40L storage capacity with adjustable foldable partition accommodates four 3600 tackle boxes plus clothing and snacks',
              'Heavy-duty 600D Oxford fabric with water-resistant PVC coating keeps gear dry in wet conditions',
              '14 dedicated pockets provide intelligent organization for rods, tools, sunglasses, and all fishing essentials',
              'Ergonomic cushioned back support with breathable foam-padded shoulder straps reduces fatigue during long treks',
              'Versatile design works perfectly for fishing, hiking, camping, and other outdoor activities beyond angling'
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4 bg-[#F8F6F3] rounded-xl p-6">
                <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-check-line text-white text-lg"></i>
                </div>
                <p className="text-lg text-gray-700 pt-1">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Things to Consider */}
      <section className="py-12 bg-[#F8F6F3]">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-8">Things to Consider</h2>
          <div className="space-y-4">
            {[
              'Large 40L capacity may feel bulky for anglers who prefer minimalist lightweight setups',
              'Fully loaded backpack can become heavy for extended hiking to remote fishing locations'
            ].map((item, index) => (
              <div key={index} className="flex items-start gap-4 bg-white rounded-xl p-6 border-2 border-orange-200">
                <div className="w-8 h-8 bg-orange-400 rounded-full flex items-center justify-center flex-shrink-0">
                  <i className="ri-information-line text-white text-lg"></i>
                </div>
                <p className="text-lg text-gray-700 pt-1">{item}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Our Verdict */}
      <section className="py-12 bg-white">
        <div className="max-w-5xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Verdict</h2>
          <div className="bg-[#2B7A9B]/5 border-l-4 border-[#2B7A9B] rounded-xl p-8">
            <p className="text-xl text-gray-700 leading-relaxed mb-6">
              The KastKing KarryAll Fishing Tackle Backpack delivers outstanding value for anglers seeking comprehensive storage and organization in a durable, comfortable package. Its intelligent 14-pocket design, water-resistant construction, and 40-liter capacity make it ideal for serious fishing enthusiasts who demand professional-grade gear management. While the fully loaded weight may challenge some users during long hikes, the ergonomic design and versatile functionality make this backpack an excellent investment for dedicated anglers and outdoor adventurers alike.
            </p>
            <div className="flex items-center justify-between pt-6 border-t border-gray-300">
              <div>
                <p className="text-sm text-gray-600 mb-2">Final Rating</p>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-2xl ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                    ))}
                  </div>
                  <span className="text-3xl font-bold text-gray-900">4.6/5</span>
                </div>
              </div>
              <a 
                href="https://amzn.to/4aNHjJa"
                target="_blank"
                rel="noopener noreferrer nofollow"
                className="bg-[#2B7A9B] text-white px-8 py-4 rounded-full font-bold hover:bg-[#236a87] transition-colors whitespace-nowrap"
              >
                Check Price on Amazon
              </a>
            </div>
            <p className="text-xs text-gray-500 text-center mt-4 leading-relaxed">
              As an Amazon Associate, we earn from qualifying purchases at no extra cost to you.
            </p>
          </div>
        </div>
      </section>

      {/* Related Reviews */}
      <section className="py-16 bg-[#F5F5F5]">
        <div className="max-w-7xl mx-auto px-6">
          <h2 className="text-4xl font-bold text-gray-900 mb-10">Related Reviews</h2>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <Link to="/tackle-accessories/plano-guide-series-stowaway-4-rack-tackle-box" className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="h-48 bg-gray-100 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/ca21489c2e47d58dcb41f66c0790959c.png"
                  alt="Plano Guide Series StowAway 4 Rack Tackle Box"
                  className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-[#2B7A9B] uppercase tracking-wide">Tackle Storage</span>
                <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3">Plano Guide Series StowAway 4 Rack Tackle Box</h3>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">(2,341)</span>
                </div>
              </div>
            </Link>

            <Link to="/tackle-accessories/kastking-speed-demon-pro-fillet-knife" className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="h-48 bg-gray-100 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/41a6fe4e75e87c50e0889f5da8f74330.png"
                  alt="KastKing Speed Demon Pro Fillet Knife"
                  className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-[#2B7A9B] uppercase tracking-wide">Knives &amp; Tools</span>
                <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3">KastKing Speed Demon Pro Fillet Knife</h3>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">(3,892)</span>
                </div>
              </div>
            </Link>

            <Link to="/tackle-accessories/piscifun-fishing-line-spooler" className="bg-white rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 hover:-translate-y-1 cursor-pointer">
              <div className="h-48 bg-gray-100 overflow-hidden">
                <img 
                  src="https://static.readdy.ai/image/2c7c87ff35994995d31b3af183ddcbb3/835a7fdafc67fe8a94c97837d9eb89da.png"
                  alt="Piscifun Fishing Line Spooler"
                  className="w-full h-full object-contain hover:scale-110 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <span className="text-xs font-bold text-[#2B7A9B] uppercase tracking-wide">Line Management</span>
                <h3 className="text-xl font-bold text-gray-900 mt-2 mb-3">Piscifun Fishing Line Spooler</h3>
                <div className="flex items-center gap-2">
                  <div className="flex items-center">
                    {[...Array(5)].map((_, i) => (
                      <i key={i} className={`ri-star-fill text-sm ${i < 4 ? 'text-yellow-400' : 'text-gray-300'}`}></i>
                    ))}
                  </div>
                  <span className="text-sm text-gray-600">(1,847)</span>
                </div>
              </div>
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#1A3A52] text-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
            <div>
              <h3 className="text-4xl font-bold mb-10">BEST FISHING GEAR</h3>
              <p className="text-white/70 leading-relaxed mb-8">
                Your trusted source for honest fishing gear reviews and expert recommendations.
              </p>
              <div className="flex items-center gap-4">
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-instagram-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-youtube-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-facebook-line text-lg"></i>
                </a>
                <a href="#" className="w-10 h-10 border-2 border-white/70 rounded-full flex items-center justify-center hover:border-white hover:bg-white hover:text-[#1A3A52] transition-all cursor-pointer">
                  <i className="ri-pinterest-line text-lg"></i>
                </a>
              </div>
            </div>

            <div>
              <h4 className="text-xs font-bold uppercase tracking-widest mb-6">Quick Links</h4>
              <ul className="space-y-3">
                <li><Link to="/" className="text-white/70 hover:text-white transition-colors">Home</Link></li>
                <li><a href="#" className="text-white/70 hover:text-white transition-colors">All Reviews</a></li>
                <li><a href="#" className="text-white/70 hover:text-white transition-colors">Buying Guides</a></li>
                <li><a href="#" className="text-white/70 hover:text-white transition-colors">Blog</a></li>
                <li><a href="#" className="text-white/70 hover:text-white transition-colors">Contact</a></li>
              </ul>
            </div>

            <div>
              <h4 className="text-xs font-bold uppercase tracking-widest mb-6">Newsletter</h4>
              <p className="text-white/70 mb-4">Get weekly gear reviews and fishing tips</p>
              <div className="flex gap-2">
                <input 
                  type="email" 
                  placeholder="Your email" 
                  className="flex-1 px-4 py-3 bg-white/10 border border-white/20 rounded-lg text-white placeholder-white/50 focus:outline-none focus:border-white/50 text-sm"
                />
                <button className="bg-[#2B7A9B] px-6 py-3 rounded-lg font-semibold hover:bg-[#236a87] transition-colors whitespace-nowrap">
                  Subscribe
                </button>
              </div>
            </div>
          </div>

          <div className="border-t border-white/20 pt-8">
            <div className="flex flex-col md:flex-row items-center justify-between gap-4">
              <p className="text-white/60 text-sm">
                © 2025 BestFishingGear.ca | Amazon Affiliate Disclosure
              </p>
              <div className="flex items-center gap-6 text-white/60 text-sm">
                <a href="#" className="hover:text-white transition-colors">Privacy Policy</a>
                <span>|</span>
                <a href="#" className="hover:text-white transition-colors">Terms</a>
                <span>|</span>
                <a href="#" className="hover:text-white transition-colors">Sitemap</a>
                <span>|</span>
                <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-white transition-colors">Powered by Readdy</a>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
}